export const columns = function () {
    return [
        {
            prop: 'insBillId',
            label: '流水号',
            fixed: 'left',
            minWidth: 150
        },
		{
		    prop: 'orgName',
		    label: '机构名称',
		    minWidth: 150
		},
		{
		    prop: 'saleName',
		    label: '业务员',
		    minWidth: 100
		},
        {
            prop: 'carNo',
            label: '车牌号',
            minWidth: 100
        },
        {
            prop: 'beginTime',
            label: '服务起期',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'endTime',
            label: '服务止期',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'cancelTime',
            label: '作废时间',
            sortable: true,
            minWidth: 200
        },
		{
		    prop: 'cancelType',
		    label: '作废类型',
		    sortable: true,
		    minWidth: 150
		},
        {
            prop: 'contractFee',
            label: '标准费用（元）',
            sortable: true,
            minWidth: 150
        },
		{
		    prop: 'cusFee',
		    label: '应交费用（元）',
		    sortable: true,
		    minWidth: 150
		},
        {
            prop: 'cusRebate',
            label: '折扣',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'commission',
            label: '手续费比例%',
            sortable: true,
            minWidth: 150
        }
    ]
}

export default {}